import { render, staticRenderFns } from "./Cassiq.vue?vue&type=template&id=6365c3cd"
import script from "./Cassiq.vue?vue&type=script&lang=ts"
export * from "./Cassiq.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports